import { map, shareReplay } from 'rxjs/operators';
import { ViewIds } from '@ardoq/api-types';
import { activeView$ } from './views/mainContent/activeView$';
import { catchErrorLogAndContinue } from './utils/streamOperators';

const currentViewId$ = activeView$.pipe(
  map(({ mainViewId }) =>
    mainViewId === ViewIds.NONE ? undefined : mainViewId
  ),
  catchErrorLogAndContinue(),
  shareReplay({ bufferSize: 1, refCount: false })
);

export { currentViewId$ };
